/** Shared table shell aligned with portal Uniquecoop styling */
export const settlementTableWrap =
  "overflow-x-auto rounded-[10px] border border-[#e0e0e0] bg-white shadow-sm";
export const settlementTh =
  "px-3 py-3 text-left text-xs font-semibold text-white bg-[#383838] whitespace-nowrap first:rounded-tl-[10px] last:rounded-tr-[10px]";
export const settlementThRight = `${settlementTh} text-right`;
export const settlementTd =
  "px-3 py-3 text-sm text-[#45464e] align-middle border-b border-[#e0e0e0] min-h-[48px]";
export const settlementTdMono = `${settlementTd} font-mono text-[13px] break-all`;
export const settlementTdRight = `${settlementTd} text-right font-medium tabular-nums`;
